module.exports = __webpack_public_path__ + "img/SingleLinkWhite.23e66606.svg";